import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { OrganizationDataLpComponent } from './organization-data-lp.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.organization-data-lp', {
            url: '/organization-data-lp',
            ncyBreadcrumb: {
                label: 'Dati Organizzazione',
                parent: 'registration.account-data'
            },
            data: {
                authorisationLevel: 0,
                pageTitle: 'Organization Data'
            },
            'views': {
                'multiContentRegistration': {
                    template: '<organization-data-lp flex="100"></organization-data-lp>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const OrganizationDataLpModule: string = ng
    .module('organization-data-lp', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('organizationDataLp', OrganizationDataLpComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/organization-data-lp/organization-data-lp.module.ts